import { render, staticRenderFns } from "./ScrollTopButton.vue?vue&type=template&id=6318aff4&scoped=true"
import script from "./ScrollTopButton.vue?vue&type=script&lang=ts"
export * from "./ScrollTopButton.vue?vue&type=script&lang=ts"
import style0 from "./ScrollTopButton.vue?vue&type=style&index=0&id=6318aff4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318aff4",
  null
  
)

export default component.exports